/* global */

const INPUT_ELEMENTS = ['.js-row-value'];
const ROW_TEMPLATE = '.js-row-template';

const Duplicate = {
  /**
   * @param {HTMLElement} node
   * @return {Void}
   */
  create(node) {
    this.node = node;
    this.rows = this.getRows();
    this.addBtn = node.querySelector('.js-add-row');
    this.template = document.querySelector(ROW_TEMPLATE).innerHTML;

    this.createEvents();
    this.refreshData();
  },

  createEvents() {
    // Listen for clicks on the add row button
    this.addBtn.addEventListener('click', () => {
      // Get the last row
      const last = this.rows[this.rows.length - 1];

      const clone = document.createElement('div');
      clone.className = 'duplicate-row js-duplicate-row clearfix';
      clone.innerHTML = this.template;

      window.pubsub.publish('components:evaluate');

      // Add the row after the last row
      last.parentNode.insertBefore(clone, last.nextSibling);

      // Get all data and output JSON to hidden input field
      this.refreshData.call(this);
    });

    // Listen for all clicks on the container
    this.node.addEventListener('click', (e) => {
      // Check if we've clicked on the remove button
      if (e.target.className.indexOf('.js-remove-row'.replace(/^\./, '')) < 0) {
        return true;
      }

      e.preventDefault();
      const { target } = e;
      const parent = target.parentNode;

      // Remove the row
      parent.parentNode.removeChild(parent);

      // Get all data and output JSON to hidden input field
      this.refreshData();

      return true;
    });

    // Listen for all keyups on the container
    this.node.addEventListener('keyup', () => {
      // Only catch it if the target is an input element
      this.refreshData();
    });
  },

  /**
   * Get an array of row nodes
   * @return {Array} List of row DOM nodes
   */
  getRows() {
    return this.nodeListToArray(document.querySelectorAll('.js-duplicate-row'));
  },

  /**
   * Removes the values of all input fields in the given node
   * @param {Node} node Row node
   * @return {Void}
   */
  emptyElementsInNode(node) {
    const inputFields = this.nodeListToArray(node.querySelectorAll(INPUT_ELEMENTS.join(', ')));

    inputFields.forEach((input) => {
      input.value = '';
    });
  },

  /**
   * Get the data for all rows, JSON stringify and output to hidden input element
   * @return {Void}
   */
  refreshData() {
    // Get all row nodes as an array
    this.rows = this.getRows.call(this);

    const vals = [];

    // Get all remove button nodes
    const removeButtons = this.nodeListToArray(this.node.querySelectorAll('.js-remove-row'));

    // Show/hide the remove button based on the number of rows
    removeButtons.forEach((btn) => {
      btn.style.display = (this.rows.length > 1) ? 'block' : 'none';
    });

    // Get the values for all rows
    this.rows.forEach((row) => {
      const elements = row.querySelectorAll('.js-row-value');

      elements.forEach((element) => {
        const val = element.value;

        vals.push(val);
      });
    });

    // Output stringified object to hidden input field
    this.node.querySelector('.js-row-output').value = JSON.stringify(vals);
  },

  /**
   * Tiny helper function to transform NodeList to an array
   * @param {NodeList} els List of nodes
   * @param {Array} Array of nodes
   */
  nodeListToArray(els) {
    return Array.prototype.slice.call(els);
  },
};

export default Duplicate;
